import { create } from 'zustand';

/**
 * Ephemeral UI state for the global command palette (⌘K / Ctrl+K). Client-only
 * (F6) — open/close is shared between the header trigger and the global hotkey.
 */
interface CommandPaletteState {
  open: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
}

export const useCommandPalette = create<CommandPaletteState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
  toggle: () => set((s) => ({ open: !s.open })),
}));
